import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/app/Home.vue'
import Ofertas from './views/app/Ofertas'
import Login from './views/auth/Login.vue'
import AuthHandle from './views/auth/AuthHandle'
import Faq from './views/app/Faq'
import Frentistas from './views/app/Frentistas'
import Postos from './views/app/Postos'
import CarteiraVirtual from './views/app/CarteiraVirtual'
import Propostas from './views/app/Propostas'
import RelatorioCompras from './views/app/RelatorioCompras'
import EditarPosto from './views/app/EditarPosto'
import RelatorioVouchers from './views/app/RelatorioVouchers'
import Contato from './views/app/Contato'
import EditarPerfil from './views/app/EditarPerfil'
import Relatorio from './views/app/Relatorio'
import RelatorioPremios from './views/app/RelatorioPremios'
import RelatorioCash from './views/app/RelatorioCash'
import RelatorioConvenio from './views/app/RelatorioConvenios'
import RelatorioPix from './views/app/RelatorioPix'
import RelatorioComprasPosto from './views/app/RelatorioComprasPosto'
import RelatorioComprasCashPosto from './views/app/RelatorioComprasCashPosto'
import RelatorioDividasCashPosto from './views/app/RelatorioDividasCashPosto'
import RelatorioVendasAssinatura from './views/app/RelatorioVendasAssinatura'
import Consolidacao from './views/app/Consolidacao'
import Configuracoes from './views/app/Configuracoes'
const MeiosDeRecebimento = () => import('./views/app/MeiosDeRecebimento')
const Convenios = () => import('./views/app/Convenios')
const Faturas = () => import('./views/app/Faturas')
const EnvioDeEmails = () => import('./views/app/EnvioDeEmails')
const MeusClientes = () => import('./views/app/MeusClientes')
const MinhasRedes = () => import('./views/app/Redes')
const RelatorioEmpresas = () => import('./views/app/RelatorioEmpresas')
const Faturamento = () => import('./views/app/Faturamento')

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/auth',
      component: AuthHandle,
      props: (route) => ({
        mode: route.query.mode,
        oobCode: route.query.oobCode,
        apiKey: route.query.apiKey,
        lang: route.query.lang
      })
    },
    {
      path: '/home',
      component: Home,
      children: [
        {
          path: '',
          component: Ofertas
        },
        {
          path: '/faturas',
          component: Faturas
        },
        {
          path: '/frentistas',
          component: Frentistas
        },
        {
          path: '/postos',
          component: Postos
        },
        {
          path: '/carteiravirtual',
          component: CarteiraVirtual
        },
        {
          path: '/propostas',
          component: Propostas
        },
        {
          path: '/convenios',
          component: Convenios
        },
        {
          path: '/relatorio',
          component: Relatorio,
          children: [
            {
              path: '/relatorio/compras',
              component: RelatorioCompras
            },
            {
              path: '/relatorio/noposto',
              component: RelatorioComprasPosto
            },
            {
              path: '/relatorio/vouchers',
              component: RelatorioVouchers
            },
            {
              path: '/relatorio/premiacoes',
              component: RelatorioPremios
            },
            {
              path: '/relatorio/compras-de-cashposto',
              component: RelatorioComprasCashPosto
            },
            {
              path: '/relatorio/cash',
              component: RelatorioCash
            },
            {
              path: '/relatorio/convenio',
              component: RelatorioConvenio
            },
            {
              path: '/relatorio/vouchers-empresas',
              component: RelatorioEmpresas
            },
            {
              path: '/relatorio/relatoriopix',
              component: RelatorioPix
            },
            {
              path: '/relatorio/dividas-cashposto',
              component: RelatorioDividasCashPosto
            },
            {
              path: '/relatorio/vendas-de-assinatura',
              component: RelatorioVendasAssinatura
            }
          ]
        },
        {
          path: '/consolidar',
          component: Consolidacao
        },
        {
          path: '/meiosderecebimento',
          component: MeiosDeRecebimento
        },
        {
          path: '/editarposto',
          component: EditarPosto
        },
        {
          path: '/editarperfil',
          component: EditarPerfil
        },
        {
          path: '/contato',
          component: Contato
        },
        {
          path: '/meufaturamento',
          component: Faturamento
        },
        {
          path: '/faq',
          component: Faq
        },
        {
          path: '/falecomcliente',
          component: EnvioDeEmails
        },
        {
          path: '/meusclientes',
          component: MeusClientes
        },
        {
          path: '/minhasredes',
          component: MinhasRedes
        },
        {
          path: '/configuracoes',
          component: Configuracoes
        }
      ]
    }
  ]
})
